import { ActionIcon, Button, Group } from '@mantine/core';
import { IconDownload, IconPrinter } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Drydock.module.css';
import type { ReportMode } from './report-export.js';

/**
 * Rapor düğmesi (ADR 0129 Ek Faz 5): PDF'i kaydet ve yazdır. `run` hata metni döndürür
 * (`null`: başarılı); hata düğmenin yanında görünür.
 */
export function DrydockReportButtons({
  label,
  run,
  busy,
  size = 'sm',
}: {
  label: string;
  run: (mode: ReportMode) => Promise<string | null>;
  busy: boolean;
  size?: 'sm' | 'compact-sm';
}) {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);
  const go = async (mode: ReportMode) => {
    setError(null);
    setError(await run(mode));
  };
  return (
    <>
      <Group gap={4} wrap="nowrap">
        <Button
          variant="default"
          size={size}
          leftSection={<IconDownload size={16} aria-hidden />}
          loading={busy}
          onClick={() => void go('save')}
        >
          {label}
        </Button>
        <ActionIcon
          variant="default"
          size={size === 'sm' ? 36 : 26}
          disabled={busy}
          aria-label={`${t('drydockReport.actions.print')} · ${label}`}
          title={t('drydockReport.actions.print')}
          onClick={() => void go('print')}
        >
          <IconPrinter size={16} aria-hidden />
        </ActionIcon>
      </Group>
      {error ? (
        <span role="alert" className={classes.reportError}>
          {error}
        </span>
      ) : null}
    </>
  );
}
